import type { DateParameter } from "~/graphql/supergraphTypes";

export { getDateParameterLabel } from "~/pages/Reporting/Settings/components/shared/DatePeriodSection/dateParameterCatalogue";

/** GraphQL exposes `DateParameter` as SCREAMING_CASE member names, but the
 * semantic layer resolves a date parameter by looking up `query.params` under
 * finpub-data-service's snake_case enum *value*. Spelled out rather than
 * lowercased so an irregularly-cased member can't silently miss, and kept
 * exhaustive so a new enum member fails typecheck instead of quietly dropping
 * a date the query requires. */
export const DATE_PARAMETER_WIRE_KEY: Record<DateParameter, string> = {
  PERIOD_BEGIN: "period_begin",
  PERIOD_END: "period_end",
  PRIOR_PERIOD_BEGIN: "prior_period_begin",
  PRIOR_PERIOD_END: "prior_period_end",
  YEAR_BEGIN: "year_begin",
  QUARTER_BEGIN: "quarter_begin",
  MONTH_BEGIN: "month_begin",
  REPORT_DATE: "report_date",
  DUE_DATE: "due_date",
  ISSUE_DATE: "issue_date",
  NOTICE_DATE: "notice_date",
  CAPITAL_CALL_DATE: "capital_call_date",
  DISTRIBUTION_DATE: "distribution_date",
  DATE_1: "date_1",
  DATE_2: "date_2",
  DATE_3: "date_3",
};
